import { render, staticRenderFns } from "./contactImport.vue?vue&type=template&id=1b45e188"
import script from "./contactImport.vue?vue&type=script&lang=js"
export * from "./contactImport.vue?vue&type=script&lang=js"
import style0 from "./contactImport.vue?vue&type=style&index=0&id=1b45e188&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports